
import React, { FC, useMemo } from "react";

import { FVI_SCHEMA } from "../../utils/constants";
import { EXXONMOBIL_ID } from "../../utils/ids";

import dayjs from "dayjs";

import Joi from "joi";
import useProjectDetails from "../../hooks/useProjectDetails";

const defaultSchema = {
    location: Joi.string().required().label('Anomaly Location'),
    description: Joi.array()
        .min(1)
        .items(
            Joi.object({
                label: Joi.string().required(),
                value: Joi.string().required(),
                __isNew__: Joi.boolean().optional(),
            })
        )
        .required()
        .label('Anomaly / Inspection Description'),
    recommendation: Joi.array()
        .min(1)
        .items(
            Joi.object({
                label: Joi.string().required(),
                value: Joi.string().required(),
                __isNew__: Joi.boolean().optional(),
            })
        )
        .required()
        .label('Remark & Recommendation'),
    class: Joi.number().min(0).required().label('Class'),
    generalImage: Joi.array().min(1).max(1).required().label('General Image'),
    closeImage: Joi.array().min(1).max(1).required().label('Close Image'),
};

function withAnomalySchema(Component: any, validationSchema: Record<string, Joi.Schema> = FVI_SCHEMA): FC<any> {
    return function WithAnomalySchema(props): JSX.Element  {
        const { projectDetails } = useProjectDetails();

        const result = useMemo(() => {
            if (projectDetails) {
                if (projectDetails.organisationId === EXXONMOBIL_ID && dayjs(projectDetails.createdAt).isAfter(dayjs('2026-04-09'), 'minutes')) {
                    return { schema: validationSchema, max: 3 };
                }
            }

            return { schema: defaultSchema, max: 1 };
        }, [projectDetails]);

        return <Component  {...props} max={result.max} schema={result.schema} />;
    };
}

export default withAnomalySchema;
